// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3Kcw4","footer":"ModalUpdate_footer__1UiRj"};